// Curated fashion colors based on major fashion retailers
// Optimized for user experience with 26 core colors

export const FASHION_COLORS = [
  // Neutrals (Most Common)
  "Black",
  "White", 
  "Gray",
  "Beige",
  "Cream",
  "Tan",
  
  // Blues
  "Navy",
  "Blue",
  "Light Blue",
  "Denim",
  
  // Earth Tones
  "Brown",
  "Khaki",
  "Olive",
  
  // Classic Colors
  "Red",
  "Burgundy",
  "Pink",
  "Rose",
  "Purple",
  "Green",
  "Yellow",
  "Orange",
  
  // Metallics
  "Gold",
  "Silver",
  
  // Patterns/Prints
  "Multi-Color",
  "Print/Pattern",
  
  // Other
  "Other"
] as const;

// Helper function to get color value for styling
export const getColorValue = (colorName: string): string => {
  const colorMap: { [key: string]: string } = {
    // Neutrals
    'Black': '#000000',
    'White': '#FFFFFF',
    'Gray': '#808080',
    'Beige': '#F5F5DC',
    'Cream': '#F5F5DC',
    'Tan': '#D2B48C',
    
    // Blues
    'Navy': '#000080',
    'Blue': '#0066CC',
    'Light Blue': '#87CEEB',
    'Denim': '#1560BD',
    
    // Earth Tones
    'Brown': '#8B4513',
    'Khaki': '#C3B091',
    'Olive': '#808000',
    
    // Classic Colors
    'Red': '#DC143C',
    'Burgundy': '#800020',
    'Pink': '#FF69B4',
    'Rose': '#FF007F',
    'Purple': '#800080',
    'Green': '#228B22',
    'Yellow': '#FFD700',
    'Orange': '#FF8C00',
    
    // Metallics
    'Gold': '#FFD700',
    'Silver': '#C0C0C0',
    
    // Patterns/Prints
    'Multi-Color': '#FF6B6B',
    'Print/Pattern': '#DDA0DD',
    
    // Other
    'Other': '#9E9E9E'
  };
  
  return colorMap[colorName] || colorName.toLowerCase();
};

// Helper function to determine light colors that need dark text
export const getLightColors = (): string[] => {
  return [
    'White', 'Cream', 'Beige', 'Light Blue', 'Yellow', 'Gold', 'Silver', 'Tan'
  ];
};

export type FashionColor = typeof FASHION_COLORS[number];